import React from 'react';

import { OverlayTrigger, PopOver } from '@tencent/spaui';

import DisassembleTable from './disassembleTable';
import MappingTable from './mapTable';

const FieldPage = () => (
  <div className="page-transet">
  <div classNameName="secs">
    <div className="card">
      <div className={'panel on'}>
        <div className="panel-heading">
          <p className="panel-title">
            多级字段拆解
            <OverlayTrigger
              trigger="hover"
              overlay={
                <PopOver classNameName="spaui-popover-transet">
                  <div className="transet-popover">
                    <p className="title">什么是多级字段拆解？</p>
                    <p className="txt">
                      开启&完成设置，当接收线索，会对需拆解的字段，按设置拆解为多个字段。例如您在落地页设置表单字段“请选择经销商”（字段类型为三级下拉，字段值包含省份、城市、经销商），设置将“请选择经销商”拆分为三个字段省份、城市、经销商，设置&开启后，当有新线索获取后，将自动拆解，替换原有字段并保存在表单信息中（可查看线索列表-表单信息进行校验）。
                    </p>
                  </div>
                </PopOver>
              }
            >
              <i className="spaui-icon icon-help"></i>
            </OverlayTrigger>
          </p>
          <DisassembleTable />
        </div>
      </div>
    </div>

    <div className="card">
      <div className={'panel on'}>
        <div className="panel-heading">
          <p className="panel-title">
            字段值映射配置
            <OverlayTrigger
              trigger="hover"
              overlay={
                <PopOver classNameName="spaui-popover-transet">
                  <div className="transet-popover">
                    <p className="title">什么是字段值映射配置？</p>
                    <p className="txt">
                      为解决销售环节和广告投放环节中，对某些字段命名和参数值设置不同，可设置字段包含落地页ID、组件ID、表单原始字段、多级字段拆解后的字段。
                    </p>
                    <p className="txt">
                      如汽车行业表单项字段设置经销商名称，但实际销售跟进过程中使用“专营店号”，此时可自主上传字段值映射配置，平台自动将广告投放收集到的线索后补齐映射后的字段&字段值（可查看线索列表-表单信息进行校验）。
                    </p>
                  </div>
                </PopOver>
              }
            >
              <i className="spaui-icon icon-help"></i>
            </OverlayTrigger>
          </p>
          <MappingTable />
        </div>
      </div>
    </div>
  </div>
  </div>
);

export default FieldPage;
